/**
 * @generated SignedSource<<637743d20166759513b3618648a0bcf9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useContentReviewerNudgeOnCriteria_content$data = {
  readonly contentState: {
    readonly id: string | null;
    readonly name: string;
    readonly unlocalizedName: string | null;
  } | null;
  readonly id: string | null;
  readonly " $fragmentType": "useContentReviewerNudgeOnCriteria_content";
};
export type useContentReviewerNudgeOnCriteria_content$key = {
  readonly " $data"?: useContentReviewerNudgeOnCriteria_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useContentReviewerNudgeOnCriteria_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDraft"
    }
  ],
  "kind": "Fragment",
  "name": "useContentReviewerNudgeOnCriteria_content",
  "selections": [
    (v0/*: any*/),
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDraft",
          "variableName": "isDraft"
        }
      ],
      "concreteType": "ContentState",
      "kind": "LinkedField",
      "name": "contentState",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "unlocalizedName"
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "4db5b656c50b670a9d0a75c802099ad4";

export default node;
